export const parseSelect = data => {
  const deptos = [];
  data.map(dtp =>
    deptos.push({
      value: Object.keys(dtp)[0],
      text: dtp[Object.keys(dtp)]
    })
  );
  return deptos;
};
